module.exports = "/_next/static/videos/SWING-30efea8ada0c055b0bf954f088fe3a93.mp4";